module.exports = {
    appName: "QIQUKAN",
    index: "HOME",
    man: "MAN",
    woman: "WOMAN",
    womanlabel: "WOMAN",
    end: "Completed",
    rank: "RANK",
    login: "LOGIN",
    reg: "REG",
    bookMsg: "My Bookshelf",
    searchMsg: "SEARCH",
    fb: "FACEBOOK PAGE",
    focus: "FOLLOW",
    kefu: "MAIL:",
    addShelf: "Add Bookshelf",
    onShelf:'已在書架',
    chooseSex:"请选择性别",
    chooseLang:"请选择语言",
    noresult: "No more novels",
    shelf: "Bookshelf",
    searchTip: "Input title or keyword",
    updateAt: "Updates",
    more: "MORE",
    account: "Account",
    memAccount: "Member Account",
    balance: "Balance",
    balancetip:"本章是VIP章節，訂閱後即可閱讀",
    coin: "Coin",
    payType: "Payment method",
    payAmount: "Payment Amount",
    resultCoin: "Gain cions",
    giftCoin: "Giftcoin",
    dollar: "Dollar",
    mlpay: "Malaysia payment",
    price: "Price",
    charge: "Top up online",
    charge2:"充值",
    paypalpay: "Paypal",
    pftpay: "Payssion",
    discount: "Discount",
    nomoredata: "No more information",
    read: "Read",
    chapters: "Check  menu",
    serialize: "To be carried forward",
    chapter: "Chapter",
    cmtList: "Join the discussion",
    cmt: "Comment",
    confirm: "Confirm",
    clickMore: "See more details",
    guessLike: "Maybe you like",
    loading: "Loading",
    free: "Free",
    total: "Total",
    "第": "NO.",
    page: "page",
    nextPage: "Next page",
    changePwd: "Set a new password",
    inputNewPwd:"請輸入新密碼",
    inputOldPwd:"請輸入舊密碼",
    inputPwd2:"請再次輸入密碼",
    oldPwd: "Original password",
    newPwd: "New password",
    confirmPwd: "Confirm your password",
    inputPwd: "Enter your password",
    inputPwd2: "Re-enter password",
    pwdNotMatch: "Passwords must match",
    changePwdSuccess: "Save changes",
    inputCmt: "Send your commments",
    feedback: "Feedback",
    inputFeedback: "Welcome to leave your precious suggestions",
    feedbackSuccess: "Your suggestion has been sent,we will reply you as soon as possible",
    lastRead: "Last read",
    latestRead: "Recent read",
    click: "Click",
    fav: "Collect",
    then: "Continue",
    readNextTime: "To read next time",
    loginPage: "Login QIQUKAN Account",
    regPage: "Register QIQUKAN Account ",
    memPwd: "Member Password",
    memLogin: "Member login",
    memReg: "sign up your account",
    inputAccount: "e-mail / phone number / name",
    myCoin: "My coins",
    langSetting: "Language settings",
    download: "Download Qiqukan",
    my: "Me",
    delShelf: "Delete bookshelf",
    home: "Return home",
    cancle: "Cancle",
    clickDownload: "INSTALL QIQUKAN APP",
    menu: "Menu",
    preChapter: "Previous",
    nextChapter: "Next",
    addShelfTip: "Add to bookshelf or not ?",
    gender: "Gender",
    male: "Man",
    female: "Woman",
    regNow: "Sign up now ",
    searchHistory: "Browsing History",
    submit: "Submit",
    detail: "Book details",
    logout:"退出登錄",
    morePay:"更多儲值",
}


//////////////////
// WEBPACK FOOTER
// ./static/lang/en.js
// module id = AQny
// module chunks = 1